import React from 'react';

interface Player {
  no: number;
  firstName: string;
  lastName: string;
  _id: string;
}

interface AssistPromptModalProps {
  open: boolean;
  goalScorer: Player | null;
  onResponse: (hasAssist: boolean) => void;
}

const AssistPromptModal: React.FC<AssistPromptModalProps> = ({ open, goalScorer, onResponse }) => {
  if (!open || !goalScorer) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white shadow-lg rounded-lg p-0 flex flex-col items-center w-full md:w-max md:min-w-[500px] max-w-[90vw] mx-4">
        <div className="relative w-full h-[120px] flex items-center justify-center overflow-hidden rounded-t-lg">
          <img
            src="/images/goal-modal-header.png"
            alt="goal"
            className="absolute top-0 left-0 w-full h-full object-cover z-[1]"
          />
          <p className="relative text-center italic font-black text-[40px] md:text-[45px] lg:text-[54px] text-sd-dark z-20 text-stroke-green">
            WE SCORED!
          </p>
        </div>
        <div className="w-full flex flex-col items-center px-6 pt-6 pb-8">
          <p className="text-xl font-semibold text-sd-dark mb-2">
            Entering goal for{' '}
            <span className="font-bold">
              {goalScorer.firstName} {goalScorer.lastName}
            </span>
          </p>
          <p className="text-3xl font-bold text-sd-dark mb-6">Was there an assist?</p>
          <div className="flex gap-4">
            <button
              className="bg-[#fff59d] text-black font-semibold px-8 py-2 rounded shadow text-xl"
              onClick={() => onResponse(true)}
            >
              Yes
            </button>
            <button
              className="bg-sd-dark text-white font-semibold px-8 py-2 rounded shadow text-xl"
              onClick={() => onResponse(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssistPromptModal;
